import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableSelectField } from '@ooh/ui/components/searchable-select-field';
import { Skeleton } from '@ooh/ui/components/skeleton';
import { suppliers } from '@ooh/contracts';
import { useApiSuspenseQuery } from '../../data/use-api-suspense-query';
import { ErrorBoundary } from '../../layouts/error-boundary';

interface PhotoSupplierPickerProps {
  value: number | null;
  onChange: (supplierId: number | null) => void;
}

function LoadedSupplierPicker({ value, onChange }: PhotoSupplierPickerProps) {
  const { t } = useTranslation('mediaImport');
  const { data: supplierList } = useApiSuspenseQuery(suppliers.list, {});
  return (
    <SearchableSelectField
      data-testid="supplier-combobox"
      options={supplierList.map((s) => ({ value: String(s.id), label: s.name }))}
      value={value !== null ? String(value) : ''}
      onChange={(val) => onChange(val !== '' ? Number(val) : null)}
      placeholder={t('upload.supplierSelectPlaceholder')}
    />
  );
}

export function PhotoSupplierPicker(props: PhotoSupplierPickerProps) {
  const { t } = useTranslation('mediaImport');
  return (
    <ErrorBoundary
      onReset={() => undefined}
      renderError={() => (
        <div
          className="rounded-md border border-red-300 bg-red-50 px-4 py-3 text-[13px] text-red-700"
          data-testid="supplier-load-error"
        >
          {t('upload.supplierLoadError')}
        </div>
      )}
    >
      <React.Suspense fallback={<Skeleton className="h-9 w-full" />}>
        <LoadedSupplierPicker {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
}
